var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.16675 14.1667C5.93064 14.1667 5.73286 14.0867 5.57342 13.9267C5.41342 13.7672 5.33342 13.5694 5.33342 13.3333V8.33333L0.500086 2.16666C0.291752 1.88888 0.260641 1.59722 0.406752 1.29166C0.552308 0.986106 0.805641 0.833328 1.16675 0.833328H12.8334C13.1945 0.833328 13.4481 0.986106 13.5943 1.29166C13.7398 1.59722 13.7084 1.88888 13.5001 2.16666L8.66675 8.33333V13.3333C8.66675 13.5694 8.58703 13.7672 8.42759 13.9267C8.26759 14.0867 8.06953 14.1667 7.83342 14.1667H6.16675ZM7.00009 7.74999L11.1251 2.49999H2.87509L7.00009 7.74999Z",
    fill: "url(#paint0_linear_2339_6643)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2339_6643",
    x1: 0.316406,
    y1: 7.5,
    x2: 13.6841,
    y2: 7.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#341E40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18B680"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterAlt);
export default __webpack_public_path__ + "static/media/filter_alt.469d534240187e3597cd6cd7e00dcd5f.svg";
export { ForwardRef as ReactComponent };